export default "__VITE_ASSET__o2SX4ZvT__"